module.exports = __webpack_public_path__ + "img/library_books.55ffc106.svg";